import { useGlobalState } from '@/hooks/use-global-state';
import { GameMode, GameType } from '@/types/api.generated';

export const useFantasyDecimalsEnabled = ({ gameMode }: { gameMode?: GameMode } = {}) => {
    const gameType = useGlobalState(state => state.allEntryRules.find(rule => rule.gameMode === gameMode)?.gameType);
    return gameType !== GameType.P2p;
};
